export const FeeTemplateQueue = {
	IsActive: {
		name: "isActive",
		beName: "active",
	},
	IsDefault: {
		name: "isDefault",
		beName: "isDefault",
	},
	TemplateId: {
		name: "templateId",
		beName: "id",
	},
	Name: {
		name: "name",
		beName: "name",
	},
};
